import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { AuthService } from "./auth.service";
import { TokenStorageService } from "./token-storage.service";

@Injectable({
	providedIn: "root",
})
export class AzureAuthService {
	constructor(
		private msalService: MsalService,
		private authService: AuthService,
		private tokenStorageService: TokenStorageService
	) {}

	logout(): void {
		const account =
			this.msalService.instance.getActiveAccount() || undefined;

		this.clearLocalSession();

		this.msalService.logoutRedirect({
			account,
		});
	}

	private clearLocalSession(): void {
		this.authService.setUserPermissions([]);
		this.authService.setUserPermissionsAsObject([]);
		this.tokenStorageService.signOut();
		localStorage.removeItem("user-data");
		localStorage.removeItem("personcompany-data");
	}
}
